angular
  .module("catalogoProdotti.components", [])
  .component("catalogoProdotti", {
    templateUrl: "ng/components/catalogoProdotti/catalogoProdotti.html",
    bindings: {
      vendorManag: "<",
      configSearch: "<",
      gestioneFornitori: "=",
    },
    controller: CatalogoProdottiController,
    controllerAs: "catalogoProdCtrl",
  });

function CatalogoProdottiController(
  $financialService,
  FileUploader,
  $configService,
  $rootScope,
  $typeDomainService,
  $timeout,
  $simulationService,
  AssetCatalog
) {
  var self = this;

  self.$onInit = function () {
    self.newCatalog = {
      lightMode: true,
      assetCatalogLight: AssetCatalog.build(),
      assetCatalog: AssetCatalog.build(),
    };
    getVendorCatalog();
    populateSelectCatalogType();
    if (self.gestioneFornitori && self.gestioneFornitori.catalogo) {
      self.newCatalog = self.gestioneFornitori.catalogo;
      if (
        self.gestioneFornitori.catalogo.lightMode &&
        self.gestioneFornitori.catalogo.assetCatalogLight &&
        (self.gestioneFornitori.catalogo.assetCatalogLight.description ||
          self.gestioneFornitori.catalogo.assetCatalogLight.value)
      ) {
        self.newCatalog.assetCatalogLight = AssetCatalog.build(
          self.gestioneFornitori.catalogo.assetCatalogLight
        );
      } else if (
        !self.gestioneFornitori.catalogo.lightMode &&
        self.gestioneFornitori.catalogo.assetCatalog &&
        self.gestioneFornitori.catalogo.assetCatalog.name
      ) {
        self.newCatalog.assetCatalog = AssetCatalog.build(
          self.gestioneFornitori.catalogo.assetCatalog
        );
        var selectedCatalog = {
          type: self.gestioneFornitori.catalogo.assetCatalog.name,
          vendorType: self.gestioneFornitori.catalogo.assetCatalog.value,
        };
        self.handleChanges(selectedCatalog, "ONINIT");
      } else if (!self.gestioneFornitori.catalogo.assetCatalog) {
        self.newCatalog.assetCatalog = AssetCatalog.build();
      } else if (!self.gestioneFornitori.catalogo.assetCatalogLight) {
        self.newCatalog.assetCatalogLight = AssetCatalog.build();
      }
    }
    verifyConfirm();
  };

  var getVendorCatalog = function () {
    var identifier = self.configSearch.selectedAppCustomerUser.ndg
      ? self.configSearch.selectedAppCustomerUser.ndg
      : "";
    self.isLoadingCatalog = true;
    $financialService
      .getVendorCatalog(identifier)
      .then(function (response) {
        self.isLoadingCatalog = false;
        self.catalogoAttualeType = response.catalogoAttualeType;
        self.vendorManag.existingCatalog =
          response.catalogoAttualeType == "CUSTOM" ? true : false;
        self.lightCatalogTypes = response.listCatalogType;
        if (
          self.gestioneFornitori.catalogo.lightMode &&
          self.gestioneFornitori.catalogo.catalogType
        ) {
          self.newCatalog.assetCatalogLight = self.lightCatalogTypes.find(
            function (obj) {
              return self.gestioneFornitori.catalogo.catalogType == obj.value
            }
          );
        }
      })
      .catch(function (err) {
        console.log(err);
        self.isLoadingCatalog = false;
      });
  };

  var populateSelectCatalogType = function () {
    self.isLoadingGetDefaultCatalogTypes = true;

    $typeDomainService
      .getDomainSet("PRODUCT_CATALOG", "TYPE")
      .then(function (response) {
        console.log("PRODUCTCATALOG", response);
        self.catalogTypes =
          response &&
          response.domainList.map(function (v) {
            return {
              type: v.value,
              vendorType: v.description,
            };
          });
        self.isLoadingGetDefaultCatalogTypes = false;
      })
      .catch(function (error) {
        console.log("ERROR getting default catalog types", error);
        self.isLoadingGetDefaultCatalogTypes = false;
      });
  };

  self.getDropdownGoodTypes = function (search, goodTypes) {
    if (goodTypes && goodTypes.length) {
      var newGoodTypes = goodTypes.slice();
      if (search && newGoodTypes.indexOf(search) === -1) {
        newGoodTypes.unshift(search);
      }
      return newGoodTypes;
    }
  };

  self.handleChanges = function (value, property) {
    switch (property) {
      case "catalogLight":
        self.newCatalog.lightMode = value;
        var obj = value
          ? self.newCatalog.assetCatalog
          : self.newCatalog.assetCatalogLight;
        Object.keys(obj).forEach(function (x) {
          obj[x] = null;
        });
        break;
      case "catalogType":
        self.newCatalog.assetCatalog.value = value.vendorType;
        self.newCatalog.assetCatalog.name = value.type;
        break;
      case "catalogLightType":
        self.newCatalog.assetCatalogLight.description = value.description;
        self.newCatalog.assetCatalogLight = value;
        self.gestioneFornitori.catalogo.catalogType = value.value
        break;
      case "ONINIT":
        self.newCatalog.type = value;
    }
    self.gestioneFornitori.catalogo = self.newCatalog;
    verifyConfirm();
  };

  var verifyConfirm = function () {
    if (self.newCatalog && !self.newCatalog.lightMode && self.newCatalog.type) {
      self.enableConfirm = true;
    } else if (
      self.newCatalog &&
      self.newCatalog.lightMode &&
      self.newCatalog.assetCatalogLight &&
      self.newCatalog.assetCatalogLight.value
    ) {
      self.enableConfirm = true;
    } else {
      self.enableConfirm = false;
    }
  };

  self.downloadCatalog = function () {
    self.isDownloading = true;
    var ndg = self.configSearch.selectedAppCustomerUser.ndg
      ? self.configSearch.selectedAppCustomerUser.ndg
      : "";
    var input = {
      ndgFornitore: ndg,
    };
    $simulationService
      .getCatalogoFromAlbagreen(input)
      .then(function (resp) {
        self.isDownloading = false;
      })
      .catch(function (err) {
        console.log(err);
        self.isDownloading = false;
      });
  };

  /** UPLOADER **/

  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item) {
    if (item) {
      self.uploadData = item;
    }
    verifyConfirm();
  };

  self.finalUpload = function () {
    console.log("calling finalUpload");
    self.folderPath = "" + new Date().getTime();
    var maintenanceString = "false";
    var url =
      $configService.getAppConfig().url +
      "/simulator/uploadProductCalalog/service-infos/" +
      self.configSearch.selectedAppCustomerUser.ndg +
      "/" +
      maintenanceString +
      "/" +
      self.gestioneFornitori.idOperation +
      "/" +
      self.vendorManag.upload.documents.catalogToUpload.nameFile;

    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    self.vendorManag.upload.uploading = true;
    self.uploader.uploadAll();
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      $("#input-upload-2").val("");
    }
    var fileName = fileItem.file.name;
    self.vendorManag.upload.documents.catalogToUpload.nameFile = fileName;
    if (fileName.toLowerCase().indexOf(".xlsx") > -1) {
      self.uploader.queue[0].progress = 0;
    } else {
      self.vendorManag.upload.documents.catalogToUpload.nameFile = null;
      fileItem.remove();
      $("#input-upload-2").val("");
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED",
      });
    }
    self.catalogSlider = true;
  };

  self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.loadingStatus.uploading = false;
  };

  self.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
    self.vendorManag.upload.uploading = false;
    jQuery("#uploadInput_2").val("");

    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    $timeout(function () {
      self.visualProgBarDoc = false;
    }, 4000);

    fileItem.remove();
    jQuery("#uploadInput_2").val("");
  };

  self.uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response.success
    ) {
      self.gestioneFornitori.catalogo.utente = response.utente;
      self.gestioneFornitori.catalogo.dataConferma = response.dataConferma;
      self.vendorManag.upload.documents.catalogToUpload.nameFile = null;
    }
    self.uploader.queue = [];

    $timeout(function () {
      self.visualProgBarDoc = false;
    }, 4000);
    jQuery("#uploadInput_2").val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    //self.vendorManag.upload.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.vendorManag.upload.uploading = false;
    if (self.vendorManag.upload.documents.catalogToUpload.nameFile) {
      //10-03-2023, Mantis 20121
      //self.vendorManag.upload.documents.catalogToUpload.nameFile = null;
      console.log("onSuccessItem!");
    }
    if (response.success) {
      self.gestioneFornitori.catalogo.utente =
        $configService.getAppConfig().user.surname ||
        $configService.getAppConfig().user.identifier;
      self.gestioneFornitori.catalogo.verificato = true;
    }
    if (!response.success) {
      $rootScope.$broadcast("addAlert", {
        text: "ERROR_UPLOADING_FILE",
      });

      self.vendorManag.upload.documents.catalogToUpload.nameFile = null;
      return;
    }
    if (self.catalogSlider) {
      $rootScope.$broadcast("addAlert", {
        text: "CATALOG_UPLOADED",
      });
      self.vendorManag.upload.documents.catalogToUpload.uploaded = true;
    }
  };

  self.confirmUploadCatalog = function () {
    self.loaderUploadCatalog = true;
    if (self.newCatalog.lightMode) {
      self.isLoadingLight = true;
      var ndg = self.configSearch.selectedAppCustomerUser.ndg
        ? self.configSearch.selectedAppCustomerUser.ndg
        : "";
      var catalogType = self.newCatalog.assetCatalogLight;
      $financialService
        .uploadFakeCatalog(
          ndg,
          self.gestioneFornitori.idOperation,
          catalogType.value
        )
        .then(function (response) {
          $rootScope.$broadcast("addAlert", {
            text: "SEND_CATALOG_REQUEST_SUCCESS",
          });
          self.isLoadingLight = false;
          self.vendorManag.mandatorySteps.uploadCatalogDone = true;
          self.gestioneFornitori.uploadCatalogDone = true;
          self.gestioneFornitori.catalogo.dataConferma = response.dataConferma;
          self.gestioneFornitori.catalogo.utente = response.utente;
          self.gestioneFornitori.catalogo.verificato = response.verificato;
        })
        .catch(function (err) {
          $rootScope.$broadcast("addAlert", {
            text: "INVALID_CATALOG",
          });
          console.log(err);
          self.isLoadingLight = false;
        });
    } else {
      if (!$("#input-upload-2").val().length) {
        self.finalUpload();
        self.vendorManag.mandatorySteps.uploadCatalogDone = true;
        self.gestioneFornitori.uploadCatalogDone = true;
        return;
      }

      if (self.vendorManag.existsVendorCatalog) {
        var input = {
          appProduct: {
            idUser: self.configSearch.selectedAppCustomerUser.ndg,
          },
        };
        HttpService.send("/simulator/getProducts", input, false).then(function (
          response
        ) {
          console.log(response.listAppProduct);
          self.listAppProduct = response.listAppProduct;

          // if catalog is in DB
          if (self.listAppProduct.length > 0) {
            $rootScope.openModal("#confirmUploadModal");
          } else {
            self.finalUpload();
            self.vendorManag.mandatorySteps.uploadCatalogDone = true;
            self.gestioneFornitori.uploadCatalogDone = true;
            verifyExistsVendorCatalog();
          }
        });
      } else {
        self.finalUpload();
        self.vendorManag.mandatorySteps.uploadCatalogDone = true;
        self.gestioneFornitori.uploadCatalogDone = true;
      }
    }

    self.loaderUploadCatalog = false;
  };

  var verifyExistsVendorCatalog = function () {
    console.log("START verifyExistsVendorCatalog");
    var input = {
      identifierAppVendor: self.configSearch.selectedAppCustomerUser.ndg,
    };
    HttpService.send("/simulator/verifyExistsVendorCatalog", input, false).then(
      function (response) {
        console.log("verifyExistsVendorCatalog=" + response.success);
        self.vendorManag.existsVendorCatalog = response.success;
        //self.catalogUploaded = true;
        exportProductCatalog();
      }
    );
  };

  var exportProductCatalog = function () {
    console.log(
      "exportProductCatalog FILE=" +
      $configService.getAppConfig().url +
      "/simulator/exportProductCatalog/service-infos/" +
      self.configSearch.selectedAppCustomerUser.ndg +
      "/" +
      "?token=" +
      $configService.getAppConfig().token
    );

    /* ESCLUSO PERCHE' AD ORA NON PREVISTO DLOAD CATALOGO */
    self.vendorManag.urls.catalogUrl =
      $configService.getAppConfig().url +
      "/simulator/exportProductCatalog/service-infos/" +
      self.configSearch.selectedAppCustomerUser.ndg +
      "/" +
      "?token=" +
      $configService.getAppConfig().token;
  };
  /** END UPLOADER */
}
